import React, { useEffect, useState, memo } from 'react';
import Grid from '@mui/material/Grid';
import DOMPurify from 'dompurify';
import TextField from '@mui/material/TextField';
import ButtomCustom from '../ButtonRound';
import FormControl from '@mui/material/FormControl';
import parse from 'html-react-parser';
import { ToastContainer } from 'react-toastify';
import OverlayLoader from '../../components/OverlayLoader';
import { getPathCourseResource } from '../../utils/electronFunctions';
import HttpClient from '../../helpers/HttpClient'; 
import { useSelector } from 'react-redux';
import { getMysqlDate } from '../../utils/generals';
import { generateIamPdf } from '../../helpers/formPdf';
import { showToast } from '../../utils/toast';
import AlertModal from '../Tests/components/AlertModal';
import './styles.scss';

const FormQuestion = ({ data, courseCode, onFinalize, onContinue }) => {
  console.log({ data, courseCode, onFinalize, onContinue })
  const [questions, setQuestions] = useState([]);
  const [openLoader, setOpen] = useState(true);
  const [openModalEnd, setOpenModalEnd] = useState(false);
  const [answers, setAnswers] = useState([]);
  const [header, setHeader] = useState(null);
  const [footer, setFooter] = useState(null);
  const [formData, setFormData] = useState(null);
  const [formSaved, setFormSaved] = useState(false);
  const authState = useSelector((state) => state.auth);
  const imagePaths = async (html, stringImages, path) => {
    const images = stringImages ? stringImages.split(',') : null;
    let content = html;
    if (Array.isArray(images)) {
      for (let i = 0; i < images.length; i++) {
        let finalPath = '';
        if (images[i].indexOf('commons/') != -1) {
          finalPath = await getPathCourseResource(
            images[i].replace('commons', 'commons')
          );
        } else {
          finalPath = await getPathCourseResource(
            path + '/img/' + images[i]
          );
        }
        content = content.replace(images[i], finalPath);
      }
    }
    return content;
  };

  const loadFormDetails = async () => {
    setOpen(true)
    setAnswers([]);
    setFormSaved(false);
    const userId = authState && authState.user ? authState.user.email : 'test';

    //llamado a api
    const request = await HttpClient().get(`/forms/form/${userId}/${data.cod_formulario}`);
    console.log(request)
    if (request.error) {
      setOpen(false)
      showToast("No se pudo cargar formulario. Refresca la página e intenta nuevamente.", "error");
      return;
    }


    const form = request.data.form;
    console.log(form);
    setFormData(form);
    const questions = request.data.questions;

    const answersForm = request.data.answers;

    console.log(answersForm);

    console.log(questions);
    if (questions) {
      setQuestions(questions);
      if (answersForm && answersForm.length > 0) {
        const answersTemp = [];
        for (let i = 0; i < questions.length; i++) {
          const r = answersForm.filter(
            (ele) => ele.id_pregunta == questions[i].id_pregunta || ele.id_pregunta == questions[i].id_pregunta_viene
          )[0];
          answersTemp.push({
            questionId: questions[i].id_pregunta,
            answerText: r ? r.respuesta : "",
            index: i,
          });
        }
        setAnswers(answersTemp);
      } else {
        //pregunta heredada
        const questionSAr = questions.filter(
          (ele) => ele.id_pregunta_viene > 0
        );
        console.log(questionSAr)
        if (questionSAr.length > 0) {
          const respTemp = Array(questions.length).fill({
            questionId: null,
            answerText: '',
            index: null,
          });
          const ids = questionSAr.map((ele) => ele.id_pregunta_viene);

          const request2 = await HttpClient().get(`/forms/question-by-id/${userId}/${ids.join(',')}`);
          
          if (request2.error) {
            setOpen(false)
            showToast("No se pudo cargar preguntas del formulario. Refresca la página e intenta nuevamente.", "error");
            return;
          }
          if (request2.data && request2.data.length > 0) {
            for (let i = 0; i < request2.data.length; i++) {
              const indext = questions.findIndex(
                (ele) => ele.id_pregunta_viene == request2.data[i].id_pregunta
              );
              respTemp[indext] = {
                questionId:  request2.data[i].id_pregunta,
                answerText:  request2.data[i].respuesta,
                index: indext,
              };
            }
          }
          setAnswers(respTemp);
        } else {
          setAnswers(
            Array(questions.length).fill({
              questionId: null,
              answerText: '',
              index: null,
            })
          );
        }
        setOpen(false)
      }
    } else {
      setAnswers([]);
      setQuestions([]);
    }
    const path = "cursos/" + courseCode;
    if (form) {
      if (form.encabezado && form.encabezado != '') {
        let htmlHeader = form.encabezado;
        if (form.img_encabezado && form.img_encabezado != '') {
          htmlHeader = await imagePaths(
            htmlHeader,
            form.img_encabezado,
            path
          );
        }
        setHeader(htmlHeader);
      } else {
        setHeader(null);
      }

      if (form.pie && form.pie != '') {
        let htmlFooter = form.pie;
        if (form.img_pie && form.img_pie != '') {
          htmlFooter = await imagePaths(htmlFooter, form.img_pie, path);
        }
        setFooter(htmlFooter);
      } else {
        setFooter(null);
      }
    }
    setOpen(false)
  };

  useEffect(() => {
    if (data) {
      loadFormDetails();
      document.getElementsByClassName("main")[0].scrollTo({ top: 0, left: 0 });
    }
  }, [data.id]);

  useEffect(() => {
    setAnswers([]);
    setQuestions([]);
    setHeader(null);
    setFooter(null);
    setFormSaved(false);
  }, []);

  useEffect(() => {
    console.log(answers);
  }, [answers]);

  const handleAnswer = (event, index) => {
    const oldState = JSON.parse(JSON.stringify(answers));
    oldState[index].questionId = questions[index].id_pregunta;
    oldState[index].answerText = event.target.value.trim();
    oldState[index].index = index;
    setAnswers(oldState);
  };

  const tranformDataToPdf = () => {
    const array = [];

    for (let i = 0; i < answers.length; i++) {
      array.push({
        question: questions[answers[i].index].pregunta,
        answer: answers[i].answerText,
      });
    }

    return array;
  };

  const saveForm = async () => {
    const empty = answers.filter((ele) => ele.answerText == '');
    if (empty.length > 0) {
      showToast('Completa todo el formulario');
    } else {
      setOpen(true);

      const userId =
        authState && authState.user ? authState.user.email : 'test';
      const currentDate = getMysqlDate();
      const arrayValues = [];

      for (let i = 0; i < answers.length; i++) {
        arrayValues.push({
          userId: userId,
          cod_formulario: formData.cod_formulario,
          questionId: answers[i].questionId,
          answerText: answers[i].answerText,
          currentDate: currentDate,
        });
      }

      const originId = data.id ? data.id : data.cod_leccion;
      const originType = data.id ? "SUBLESSON" : "LESSON";

      const request = await HttpClient().post(`/forms/save/${userId}/${originId}/${data.cod_formulario}/${originType}`, arrayValues)


      setTimeout(() => {
        setOpen(false);
        setFormSaved(true);
        onFinalize();
        if (formData.texto_boton && formData.texto_boton != '') {
          setOpenModalEnd(true);
        }
      }, 1000);
    }
  };

  const ButtonDownload = () => {
    return (
      <ButtomCustom
        variant="contained"
        onClick={async () => {
          const title =
            data.tipo == 'T2'
              ? 'Yo Soy'
              : data.tipo == 'C'
              ? 'MI PROYECTO DE VIDA'
              : '';
          await generateIamPdf(title, tranformDataToPdf());
        }}
        rounded
      >
        {formData.texto_boton}
      </ButtomCustom>
    );
  };

  return (
    <Grid container columns={{ xs: 4, md: 12 }} spacing={2}>
      <OverlayLoader open={openLoader} />
      <Grid item xs={12}>
        {header ? <div>{parse(header)}</div> : null}
      </Grid>
      <Grid item xs={12}>
        <div className="questions-container" key={data.cod_formulario}>
          {questions && questions.length > 0 ? (
            <div key={'container'}>
              {questions.map((question, index) => (
                <div key={question.id_pregunta} className="question-container-form">
                  <div className="question">
                    <div>{parse(question.pregunta)}</div>
                  </div>
                  <div className="answer-container" key={question.id_pregunta}>
                    <FormControl sx={{ minWidth: 120, width: '100%' }} key={question.id_pregunta}>
                      <TextField
                        id="outlined-multiline-static"
                        label=""
                        multiline={
                          question.unilinea && question.unilinea == 1
                            ? false
                            : true
                        }
                        key={question.id_pregunta}
                        rows={3}
                        defaultValue={
                          answers[index] && answers[index].answerText != ''
                            ? answers[index].answerText
                            : ''
                        }
                        onChange={(event) => {
                          handleAnswer(event, index);
                        }}
                      />
                    </FormControl>
                  </div>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </Grid>

      <Grid item xs={12}>
        {footer ? <div>{parse(footer)}</div> : null}
      </Grid>

      <Grid item xs={12} className="lessons-button-container-center">
        {!formSaved ? (
          <ButtomCustom
            variant="contained"
            onClick={() => {
              saveForm();
            }}
            rounded
          >
            Guardar
          </ButtomCustom>
        ) : (
          <ButtomCustom
            variant="contained"
            onClick={() => {
              onContinue();
            }}
            rounded
          >
            Continuar
          </ButtomCustom>
        )}
      </Grid>
      {/*<ToastContainer />*/}
      {formData && formData.texto_boton && formData.texto_boton != '' ? (
        <AlertModal
          open={openModalEnd}
          title={''}
          content={ButtonDownload()}
          buttonText={'Cerrar'}
          onButtonClick={() => {
            setOpenModalEnd(false);
          }}
        />
      ) : null}
    </Grid>
  );
};

export default memo(FormQuestion);
